import { Stack, Typography } from '@mui/material';
import React from 'react';

import { DotIcon } from '@/shared/assets/icons/dot-icon';
import { TListItemDescriptionProps } from '@/shared/components/ui/list-item-description/list-item-description.types';

export const ListItemDescription: React.FC<TListItemDescriptionProps> = ({
  text1,
  text2,
}) => {
  return (
    <Typography variant="p10" color="textSecondary">
      <Stack direction="row" alignItems="center" gap="0.25rem">
        {text1} <DotIcon variant="light" />
        {text2}
      </Stack>
    </Typography>
  );
};
